/***************************************************************************
 * 版权所有 (C) 2013, Rapid7 LLC, Boston, MA, USA。
 * 保留所有权利。本材料含有未发布的、受版权保护的
 * 内容，包括 Rapid7 的机密和专有信息。
 **************************************************************************/

const vulnerabilitiesByCvssScoreLabeling = {
  label: {
    cntHigh: '__percent__ (__value__) 7.0 和 10',
    cntLow: '__percent__ (__value__) 0 和 3.9',
    cntMedium: '__percent__ (__value__) 4.0 和 6.9',
  },
  summary: {
    cntHigh: '__percent__的漏洞 CVSS 分数在 7.0 至 10 之间',
    cntLow: '__percent__的漏洞 CVSS 分数在 0 至 3.9 之间',
    cntMedium: '__percent__的漏洞 CVSS 分数在 4.0 至 6.9 之间',
  },
  value: {
    cntHigh: '__percent__ (__value__) 的漏洞 CVSS 分数在<br/> 7.0 至 10 之间',
    cntLow: '__percent__ (__value__) 的漏洞 CVSS 分数在<br/> 0 至 3.9 之间',
    cntMedium:
      '__percent__ (__value__) 的漏洞 CVSS 分数在<br/> 4.0 至 6.9 之间',
  },
};
const vulnerabilitiesBySeverityLabeling = {
  label: {
    cntCritical: '__percent__ (__value__) 高危漏洞',
    cntModerate: '__percent__ (__value__) 低危漏洞',
    cntSevere: '__percent__ (__value__) 中危漏洞',
    cntSeverityUnknown: '__percent__ (__value__) 未知漏洞',
  },
  summary: {
    cntCritical: '您的__percent__的漏洞为高危',
    cntModerate: '您的__percent__的漏洞为低危',
    cntSevere: '您的__percent__的漏洞为中危',
    cntSeverityUnknown: '您的__percent__的漏洞为未知',
  },
  value: {
    cntCritical: '您的__percent__ (__value__) 的漏洞为高危',
    cntModerate: '您的__percent__ (__value__) 的漏洞为低危',
    cntSevere: '您的__percent__ (__value__) 的漏洞为中危',
    cntSeverityUnknown: '您的__percent__ (__value__) 的漏洞为未知',
  },
};

const dayRangeLabels = {
  0: '0-29 天',
  1: '30-59 天',
  2: '60-90 天',
  3: '> 90 天',
};
const severityLabels = {
  0: '$t(moderate)',
  1: '$t(severe)',
  2: '$t(critical)',
};
const cvssScoreLabels = {
  0: '0.1-3.9',
  1: '4.0-6.9',
  2: '7.0-10',
};

/* jshint maxlen: false */
export default {
  translation: {
    acronym: {
      vulnerabilities: '漏洞',
    },
    active: '活动',
    activelyExploited: {
      entity: {
        cve: 'CVE',
        dateAdded: '添加的日期',
        description: '描述',
        rationale: '根本原因',
        source: '来源',
        target: '目标',
      },
      title: 'Rapid7 威胁来源详细信息',
    },
    add: '添加',
    addCard: '添加卡片',
    addCardTitle: '添加卡片',
    addDashboard: '添加仪表板',
    added: '已添加',
    address: '地址',
    addresses: '地址',
    admin: {
      manageFilters: '$t(manage) $t(filters)',
      title: '$t(manage) 元素',
    },
    affects: '影响',
    agent: '代理',
    agentConnectionDetail: '代理连接详情',
    agentDownloadTitle: '下载 Rapid7 代理',
    agentDownloadTitle2: '下载、安装&amp;、部署代理',
    agentID: '代理 ID',
    agentInstructions:
      '<p>将 zip 压缩文件案复制到系统中。解压文件。为您提供两种 MSI 安装程序，一种用于 32 位 Windows 系统及 config.json，另一种用于 64 位 Windows 系统及 config.json，共有三种安全文件：client.key、client.crt 以及 cafile.pem。</p><p>执行相关 MSI 安装程序，即可安装代理程序。在默认情况下，代理程序的安装位置将为：c:\\Program Files (x86)\\Rapid7\\Endpoint Agent，同时还将自动安装安全文件。代理程序将作为服务进行安装，您可将其作为“Rapid7 端点代理程序”进行查看。</p><p>作为代理程序操作的一部分，会将信息记录至“agent.log”文件中。同时，还可将此档案分为 agent.log.1 和 agent.log.2。如发生问题，我们可能会要求您提供这些日志文件，以便我们执行故障排除。</p>',
    agentManagement: '管理代理',
    agentManagerTitle: '代理',
    agentStatus: '代理状态',
    agentVersion: '版本',
    agents: '代理',
    agentsCount: '__count__ 个代理',
    agentsOldVersion: '使用旧版本',
    agentsPage: {
      chartTitle: '按操作系统划分的已连接代理的资产',
      summary: '我的__percent__已连接代理的资产正在运行__os__操作系统',
    },
    agentsRecentlyAssessed: '近期已评估',
    alert: '警报',
    allCards: '所有 $t(cardsLabel)',
    and: '和',
    apply: '应用',
    approvedBy: '批准者',
    architecture: '架构',
    areYouSure: '您是否确定？',
    assessed: '已评估',
    asset_groups: '资产组',
    asset_indefinite: '资产',
    asset_plural: '__count__ 个资产',
    asset_plural_indefinite: '资产',
    assetCount: '资产计数',
    assetDetails: {
      contextDrivenRiskScore: '环境驱动风险评分',
      fetchFailed: '检索资产失败，请稍后重试。',
      kpi: {
        malware: '恶意软件包',
        operatingSystemFingerprints: '指纹',
      },
      rotatedTitle: '查看资产概述',
      save: '保存',
    },
    assetDetailsLabel: '资产细节',
    assetGroup: '资产组',
    assetGroups: {
      donutTitle: '风险最高组',
      labels: {
        assets: '资产',
      },
      title: '风险最高的主要资产组',
    },
    assetGroupsLabel: '资产组',
    assetLabel: '资产',
    assetName: '资产名称',
    assets: '资产',
    assetsAffected: '受影响资产的数量',
    assetsByComponent: {
      OS: {
        title: '按操作系统划分的资产',
      },
      assessmentStatus: {
        title: '按评估状态划分的资产',
      },
    },
    assetsWithUnknownOS:
      '我的 $t(assets) 正在运行未经确认的 $t(operatingSystem)',
    assignTo: '分配至',
    assignees: '受让人',
    availableDashboard: '可用的仪表板',
    backToAll: '清除选择',
    basicInfo: '基本信息',
    cancel: '取消',
    cardActions: {
      close: '关闭',
      noChanges: '卡片没有要保存的变更',
      save: '保存卡片',
      saveAs: '另存为新卡',
      saveError: '更新卡片时出错。请稍后重试。',
      savedExistingFilter: '您的过滤器已更新。',
      savedExistingFilterSelection: '您的卡片已更新。',
      savedExistingFilterSelectionAndFilterContent:
        '您的过滤器已保存，且您的卡片已更新。',
      savedExistingFilterToNewCard:
        '您的现有过滤器已保存，且已应用至您的新卡片。',
      savedNewCard: '您的新卡片已创建。',
      savedNewFilterToExistingCard: '您的新过滤器已保存，且您的卡片已更新。',
      savedNewFilterToNewCard: '已将您的新过滤器保存至新卡片。',
      savedWithExistingFilter: '您的现有过滤器和卡片已更新。',
      unsavedChanges: '卡片有未保存的变更。是否继续？',
    },
    cardEditModal: {
      errors: {
        titleInUse: '此名称已在使用中',
        titleRequired: '卡片名称不能为空',
      },
      placeholder: {
        name: '卡片名称',
      },
      title: {
        saveAs: '另存为',
      },
    },
    cardLibrary: {
      card: {
        'riskiest-sites': {
          description: '风险最高的场所、资产和他们的漏洞',
          name: '风险最高的场所',
        },
      },
      category: {
        agents: '$t(agents)',
        assets: '$t(assets)',
        exploitableVulns: '$t(exploitableVulns)',
        kpi: '$t(kpi)',
        remediations: '$t(remediations)',
        risk: '$t(risk)',
        sites: '$t(sites)',
        vulns: '$t(vulns)',
      },
    },
    cardSearch: '搜索卡片',
    cardTemplates: {
      AgentsByOS: {
        description: '含有按操作系统划分且已连接代理的资产分解的卡片。',
        name: '按操作系统划分的已连接代理的资产',
        summary: '我的__percent__已连接代理的资产正在运行__os__操作系统',
        value: '我的__percent__ (__value__) 资产正在运行__os__操作系统',
      },
      AssetsByLastScanDate: {
        description: '显示一份按资产最近扫描的方式分组的资产图表。',
        label: {
          later: '> 120 天',
          'period 1': '0-30 天',
          'period 2': '30-60 天',
          'period 3': '60-90 天',
          'period 4': '90-120 天',
        },
        name: '按最后扫描日期划分的资产',
        summary: {
          later: '在 120 多天前，我的__percent__资产已扫描',
          'period 1': '在过去 30 天内，我的__percent__资产已扫描',
          'period 2': '在 30-60 天前，我的__percent__资产已扫描',
          'period 3': '在 60-90 天前，我的__percent__资产已扫描',
          'period 4': '在 90-120 天前，我的__percent__资产已扫描',
        },
        value: {
          later: '在 120 多天前，我的__percent__ (__value__) 资产已扫描',
          'period 1': '在 30 天前，我的__percent__ (__value__) 资产已扫描',
          'period 2': '在 30-60 天内，我的__percent__ (__value__) 资产已扫描',
          'period 3': '在 60-90 天内，我的__percent__ (__value__) 资产已扫描',
          'period 4': '在 90-120 天内，我的__percent__ (__value__) 资产已扫描',
        },
      },
      AssetsByOS: {
        description: '含有按操作系统划分的资产分解的卡片。',
        name: '按操作系统划分的资产',
        summary: '我的__percent__资产正在运行__os__操作系统',
        value: '我的__percent__ (__value__) 资产正在运行__os__操作系统',
      },
      AssetsByTotalScanTime: {
        description: '显示按扫描时间分组的资产图表。',
        label: {
          cntScanTime10To20: '10-20 分钟',
          cntScanTime20To30: '20-30 分钟',
          cntScanTime30To40: '30-40 天分钟',
          cntScanTimeGt40: '> 40 分钟',
          cntScanTimeLt10: '0-10 分钟',
        },
        name: '按总扫描时间划分的资产',
        summary: {
          cntScanTime10To20: '我的__percent__资产需要 10-20 分钟完成扫描',
          cntScanTime20To30: '我的__percent__资产需要 20-30 分钟完成扫描',
          cntScanTime30To40: '我的__percent__资产需要 30-40 分钟完成扫描',
          cntScanTimeGt40: '我的__percent__资产需要逾 40 分钟完成扫描',
          cntScanTimeLt10: '我的__percent__资产需要 0-10 分钟完成扫描',
        },
        value: {
          cntScanTime10To20:
            '我的__percent__ (__value__) 资产需要 10-20 分钟完成扫描',
          cntScanTime20To30:
            '我的__percent__ (__value__) 资产需要 20-30 分钟完成扫描',
          cntScanTime30To40:
            '我的__percent__ (__value__) 资产需要 30-40 分钟完成扫描',
          cntScanTimeGt40:
            '我的__percent__ (__value__) 资产需要逾 40 分钟完成扫描',
          cntScanTimeLt10:
            '我的__percent__ (__value__) 资产需要 0-10 分钟完成扫描',
        },
      },
      AssetsByVulnSeverity: {
        description: '显示存在按严重性分组的漏洞的资产',
        label: {
          critical: '__percent__ (__value__) 高危漏洞',
          moderate: '__percent__ (__value__) 低危漏洞',
          severe: '__percent__ (__value__) 中危漏洞',
          unknown: '__percent__ (__value__) 未知漏洞',
        },
        name: '按漏洞严重性划分的资产',
        summary: {
          critical: '__percent__的我的资产有高危漏洞',
          moderate: '__percent__的我的资产有低危漏洞',
          severe: '__percent__的我的资产有中危漏洞',
          unknown: '__percent__的我的资产未检测到已知的漏洞',
        },
        value: {
          critical: '__percent__ (__value__) 的我的资产有高危漏洞',
          moderate: '__percent__ (__value__) 的我的资产有低危漏洞',
          severe: '__percent__ (__value__) 的我的资产有中危漏洞',
          unknown: '__percent__ (__value__) 的我的资产未检测到已知的漏洞',
        },
      },
      AssetsCriticalVuln: {
        description:
          '显示带有非预计高危风险漏洞（CVSS 分数超过 8）的资产的数量。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '带有高危风险漏洞的资产',
        summary: {
          assetCount: '带有高危漏洞',
        },
      },
      AssetsNewlyDiscoveredXDays: {
        description: '显示在指定时间框架内在环境中新发现的资产的数量。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '新发现的资产',
        summary: {
          assetCount: '新发现的',
        },
      },
      AssetsWithActivelyExploitedVulnerabilities: {
        description:
          '通过利用 Rapid7 实验室的 Heisenberg 蜜罐系统、事件响应活动及可信第三方的信息，Rapid7 设计了最危险的可利用漏洞威胁来源。此卡片中显示了受这些漏洞影响的资产数。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '含有活动的目标漏洞的资产',
        summary: {
          assetCount: '含有活动的目标漏洞',
        },
      },
      AssetsWithDefaultAccountVulns: {
        description: '显示漏洞与使用默认账户相关的资产数量。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '带有默认账户漏洞的资产',
        summary: {
          assetCount: '带有默认账户漏洞',
        },
      },
      AssetsWithKnownObsoleteOS: {
        description: '目前正在运行已知淘汰的操作系统的资产百分比。',
        label: {
          assetCount: '包含已淘汰操作系统的资产',
          otherCount: '剩余资产',
        },
        name: '运行已淘汰操作系统的资产',
        summary: {
          assetCount: '__percent__运行已淘汰操作系统的资产',
          otherCount: '__percent__未运行已淘汰操作系统的资产',
        },
        value: {
          assetCount: '__percent__ (__value__) 的资产包含已淘汰的操作系统',
          otherCount: '__percent__ (__value__) 剩余资产',
        },
      },
      ChangeInNumberOfAssets: {
        description:
          '显示资产的总数，以及该数字如何在指定的时间段内变化，便于您可以监控关键绩效指标。',
        label: {
          totalAssets: '总资产',
        },
        name: '总资产趋势',
        summary: {
          assetCount: '增加__value__ (__percent__) ',
        },
      },
      ContainerCountsCard: {
        description: '显示资产容器计数的卡片',
        name: '计数',
      },
      CredentialSuccessCard: {
        description: '显示认证成功的资产。',
        label: {
          cntCredentialFailure: '__percent__ (__value__) 登录失败',
          cntCredentialSuccess: '__percent__ (__value__) 登录成功',
          cntCredentialUnknown: '__percent__ (__value__) 未尝试登录',
        },
        name: '按认证状态划分的资产',
        summary: {
          cntCredentialFailure: '我的__percent__资产已登录失败',
          cntCredentialSuccess: '我的__percent__资产登录成功',
          cntCredentialUnknown: '我的__percent__资产未尝试登录',
        },
        value: {
          cntCredentialFailure: '我的__percent__ (__value__) 资产登录失败',
          cntCredentialSuccess: '我的__percent__ (__value__) 资产登录成功',
          cntCredentialUnknown: '我的__percent__ (__value__) 资产未尝试登录',
        },
      },
      CredentialSuccessOverTime: {
        description:
          '显示了关于资产凭证随着时间推移成功或失败的信息和图表的卡片',
        label: {
          credentialFailedAssetCount: '$t(failed)',
          credentialSuccessAssetCount: '$t(successful)',
          credentialUnknownAssetCount: '$t(unknown)',
        },
        name: '随着时间推移的凭证登录成功',
        value: {
          credentialFailedAssetCount:
            '$t(weekOf)<br/>$t(failed) __percent__ (__value__)',
          credentialSuccessAssetCount:
            '$t(weekOf)<br/>$t(successful) __percent__ (__value__)',
          credentialUnknownAssetCount:
            '$t(weekOf)<br/>$t(unknown) __percent__ (__value__)',
        },
        yAxisLabel: '$t(percentOfAssets)',
      },
      ExpiredSSLCertificatesCard: {
        description: '显示在您的环境中当前拥有过期 SSL 证书的资产的数量。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '带有过期 SSL 证书的资产',
        summary: {
          assetCount: '带有过期 SSL 证书',
        },
      },
      ExpiredVulnExceptionTableComponent: {
        description: '显示了在您的环境中最近过期的漏洞例外情况的卡片。',
        name: '最近到期的漏洞例外情况',
      },
      ExpiringSSLCertificatesCard: {
        description:
          '显示在您的环境中 SSL 证书将要在指定时间框架内到期的资产的数量。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '带有即将过期的 SSL 证书的资产',
        summary: {
          assetCount: '带有即将过期的 SSL 证书',
        },
      },
      ExpiringVulnExceptionTableComponent: {
        description: '显示了在您的环境中即将过期的漏洞例外情况的卡片。',
        name: '漏洞例外情况即将到期',
      },
      ExploitableAssetsBySkillLevel: {
        description:
          '显示您环境中的资产分解，按利用资产漏洞所需的技能级别划分。',
        label: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__ (__value__) 无已知的漏洞利用程序',
          cntMinSkillLevelRankExpert: '__percent__ 专家',
          cntMinSkillLevelRankIntermediate: '__percent__ 中间人',
          cntMinSkillLevelRankNovice: '__percent__ (__value__) 新手',
        },
        name: '按技能级别划分的可利用资产',
        summary: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__的资产无已知的漏洞利用程序',
          cntMinSkillLevelRankExpert: '__percent__的资产可能被专家利用',
          cntMinSkillLevelRankIntermediate:
            '__percent__的资产cntSkillUnknown可能通过中间人技能进行利用',
          cntMinSkillLevelRankNovice: '__percent__的资产可能被新手利用',
        },
        value: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__ (__value__) 的资产无已知的漏洞利用程序',
          cntMinSkillLevelRankExpert:
            '__percent__ (__value__) 的资产可能被专家利用',
          cntMinSkillLevelRankIntermediate:
            '__percent__ (__value__) 的资产可能通过中间人技能进行利用',
          cntMinSkillLevelRankNovice:
            '__percent__ (__value__) 的资产可被新手利用',
        },
      },
      ExploitableVulnByCVSSscore: {
        description:
          '按 CVSS 分数分解您环境中可利用的漏洞百分比，以便您可以根据一般标准了解您环境中哪部分的风险较高。',
        name: '按 CVSS 分数划分的可利用漏洞',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      ExploitableVulnDiscoverByTotalRiskScore: {
        description:
          '显示在过去 90 天内发现的可利用漏洞，按总风险评分从高至低分类。',
        name: '按总风险评分划分的新发现的可利用漏洞',
      },
      ExploitableVulnerabilities: {
        description:
          '显示您的环境中漏洞总数量以及该数量在指定的时间段内如何变化的卡片。',
        label: {
          count: '$t(vulns)',
        },
        name: '可利用的漏洞计数',
        summary: {
          count: '可利用的漏洞',
        },
      },
      ExploitableVulnerabilitiesBySeverity: {
        description: '按严重性级别显示您环境中可利用漏洞的百分比分解。',
        name: '按严重性划分的可利用漏洞',
        ...vulnerabilitiesBySeverityLabeling,
      },
      ExploitableVulnerabilityAgeByCVSS: {
        description:
          '重点显示了您环境中按 CVSS 分数排列的可利用漏洞发现时间的卡片',
        name: '按 CVSS 分数划分的可利用漏洞发现日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityDiscoveryDateBySeverity: {
        description: '重点显示了您环境中按严重性排列的可利用漏洞发现时间的卡片',
        name: '按严重性划分的可利用漏洞发现日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishAgeBySeverity: {
        description: '按严重性详细说明了在您的环境中可利用漏洞发布寿命的卡片',
        name: '按严重性划分的可利用漏洞发布寿命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishDateByCVSS: {
        description: '按 CVSS 分数列出的可利用漏洞发布日期的卡片',
        name: '按 CVSS 分数划分的可利用漏洞发布寿命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnsBySkillLevel: {
        description: '显示您环境中的漏洞分解，按利用它们所需的技能级别划分。',
        label: {
          cntExpert: '__percent__ 专家',
          cntIntermediate: '__percent__ 中间人',
          cntNovice: '__percent__ (__value__) 新手',
          cntSkillUnknown: '__percent__ (__value__) 无已知的漏洞利用程序',
        },
        name: '按技能级别划分的可利用漏洞',
        summary: {
          cntExpert: '__percent__ 的漏洞可能被专家利用',
          cntIntermediate: '__percent__ 的漏洞可能通过中间人技能进行利用',
          cntNovice: '__percent__ 的漏洞可能被新手利用',
          cntSkillUnknown: '__percent__的漏洞不包含已知的漏洞利用程序',
        },
        value: {
          cntExpert: '__percent__ (__value__) 的漏洞可能被专家利用',
          cntIntermediate:
            '__percent__ (__value__) 的漏洞可能通过中间人技能进行利用',
          cntNovice: '__percent__ (__value__) 的漏洞可能被新手利用',
          cntSkillUnknown:
            '__percent__ (__value__) 的漏洞不包含已知的漏洞利用程序',
        },
      },
      MostCommonExploitableVulnComponent: {
        description: '根据受影响的资产数显示在您的环境中最常见漏洞的卡片。',
        name: '最常见的可利用漏洞',
      },
      MostCommonExploitedVulnComponent: {
        description:
          '通过利用 Rapid7 实验室的 Heisenberg 蜜罐系统、事件响应活动及可信第三方的信息，Rapid7 设计了最危险的可利用漏洞威胁来源。此卡片显示了您的环境中按受影响资产数排列的漏洞详细信息。',
        name: '含有活动的目标漏洞的资产',
      },
      MostCommonExploitsComponent: {
        description: '根据受影响的资产数显示在您的环境中最常见的漏洞利用程序。',
        name: '最常见的漏洞利用程序',
      },
      MostCommonMalwareKitsComponent: {
        description: '根据受影响的资产数显示在您的环境中最常见的恶意软件包。',
        name: '最常见的恶意软件包',
      },
      MostCommonVulnComponent: {
        description: '根据受影响的资产数显示在您的环境中最常见漏洞的卡片。',
        name: '最常见的漏洞',
      },
      NewVsRemediatedVulnerabilities: {
        description:
          '将自既定日期起发现的已修复漏洞、发现的新漏洞及发现的未改变漏洞计数进行对比的卡片。',
        label: {
          newFindings: '发现__percent__ (__value__) 的新漏洞',
          remediatedFindings: '发现__percent__ (__value__) 的已修复漏洞',
          unchangedFindings: '发现__percent__ (__value__) 的未改变漏洞',
        },
        name: '新漏洞与已修复漏洞',
        summary: {
          newFindings: '发现__percent__ 的新漏洞',
          remediatedFindings: '发现__percent__ 的已修复漏洞',
          unchangedFindings: '发现__percent__ 的未改变漏洞',
        },
        value: {
          newFindings: '发现__percent__ (__value__) 的新漏洞',
          remediatedFindings: '发现__percent__ (__value__) 的已修复漏洞',
          unchangedFindings: '发现__percent__ (__value__) 的未改变漏洞',
        },
      },
      NumberOfConnectedAgentsComponent: {
        description: '显示在您的环境中已连接代理的资产数量的卡片。',
        label: {
          assetCount: '$t(assets)',
        },
        name: '已连接代理的资产数量',
        summary: {
          assetCount: '含有已连接代理',
        },
      },
      ObsoleteSoftwareCard: {
        description: '详细描述了网络内已淘汰/未淘汰资产的卡片。',
        label: {
          assetCount: '含有已淘汰软件的资产',
          otherCount: '剩余资产',
        },
        name: '运行已淘汰软件的资产',
        summary: {
          assetCount: '__percent__ 的资产安装了已知的淘汰软件',
          otherCount: '__percent__ 的资产未安装已知的淘汰软件',
        },
        value: {
          assetCount: '__percent__ (__value__) 的资产安装了已知的淘汰<br/>软件',
          otherCount: '__percent__ (__value__) 的资产未安装已知的淘汰<br/>软件',
        },
      },
      ProjectsAtRiskCard: {
        description: '显示即将到期但仍处于开启状态的项目数量。',
        label: {
          totalElements: '正在关闭项目',
        },
        name: '存在风险的项目',
        summary: {
          totalElements: '',
        },
      },
      ProjectsMostRemainingWorkCard: {
        description: '列出含有未解决修复项目数量最多的项目。',
        name: '剩余工作',
      },
      ProjectsMostRemainingWorkPercentCard: {
        description: '列出含有未解决修复项目数量最多的项目。',
        name: '剩余工作 %',
      },
      ProjectsPastDueCard: {
        description: '显示过期项目的数量。',
        label: {
          totalElements: '$t(projects)',
        },
        name: '过期项目',
        summary: {
          totalElements: '已过期',
        },
      },
      ProjectsRecentlyClosedCard: {
        description: '显示近期关闭的项目数量。',
        label: {
          totalElements: '已关闭项目',
        },
        name: '近期关闭的项目',
        summary: {
          totalElements: '',
        },
      },
      RemediatedVulnerabilities: {
        description: '列出在您的环境中在过去 30 天内数量减少的漏洞。',
        name: '已修复的主要漏洞',
      },
      RemediatorsRequiringAssistance: {
        description: '列出包含依然开启、但已过期项目数量最多的项目拥有者。',
        name: '需要协助的修复人员',
      },
      RiskVulnsCard: {
        description: '显示按风险和漏洞数量排序的资产散点图',
        name: '按风险和漏洞划分的资产',
        summary: {
          selected: '主机名称：__name__',
        },
        value: '我的__percent__ (__value__) 资产正在运行__os__操作系统',
      },
      TopRemediators: {
        description: '列出含有成功按时关闭的项目数量最多的项目拥有者。',
        name: '最主要的修复人员',
      },
      TopRiskiestAssetGroupsComponent: {
        description: '列出在您的环境中风险评分最高的资产组。',
        name: '风险最高的主要资产组',
      },
      TopRiskiestAssetLocationsComponent: {
        description: '列出在您的环境中总风险最高的位置。',
        name: '风险最高的主要资产位置',
      },
      TopRiskiestAssetOwnersComponent: {
        description: '列出资产总风险最高的资产拥有者。',
        name: '风险最高的主要资产拥有者',
      },
      TopRiskiestAssetsComponent: {
        description: '列出在您的环境中风险最高的资产。',
        name: '风险最高的主要资产',
      },
      TopRiskiestSitesComponent: {
        description: '列出在您的环境中总风险最高的场所。',
        name: '风险最高的主要场所',
      },
      TotalVulnerabilities: {
        description: '显示了在您的环境中在一段指定时间内漏洞数量变化的卡片。',
        label: {
          count: '$t(vulns)',
        },
        name: '漏洞数',
        summary: {
          count: '漏洞总数',
        },
      },
      TrendingVulnerabilities: {
        description: '列出在您的环境中在过去 30 天内数量增加的漏洞。',
        name: '趋势最明显的主要漏洞',
      },
      VulnByCVSSscore: {
        description:
          '按 CVSS 分数分解您环境中的漏洞百分比，以便您可以根据一般标准了解您环境中的哪部分的风险较高。',
        name: '按 CVSS 分数划分的漏洞',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      VulnDiscoverByTotalRiskScore: {
        description: '显示在过去 90 天内发现的漏洞，按总风险评分从高至低分类。',
        name: '按总风险评分划分的新发现漏洞',
      },
      VulnRiskOverTime: {
        description:
          '显示环境内的漏洞风险趋势，便于您了解总风险随着时间推移是否增加或下降。',
        name: '随着时间推移的漏洞风险评分',
        value: {
          riskScore: '$t(weekOf)<br/>$t(riskScoreLabel) __value__',
        },
        yAxisLabel: '$t(riskScoreLabel)',
      },
      VulnTrends: {
        description: '显示了随着时间推移的漏洞趋势的卡片。',
        label: {
          cntCritical: '$t(critical)',
          cntModerate: '$t(moderate)',
          cntSevere: '$t(severe)',
        },
        name: '按随着时间推移的漏洞严重性划分的资产',
        value: {
          cntCritical: '$t(weekOf)<br/>$t(critical) __percent__ (__value__)',
          cntModerate: '$t(weekOf)<br/>$t(moderate) __percent__ (__value__)',
          cntSevere: '$t(weekOf)<br/>$t(severe) __percent__ (__value__)',
        },
      },
      VulnerabilitiesBySeverity: {
        description: '按严重性级别显示您环境中的漏洞百分比分解。',
        name: '按严重性划分的漏洞',
        ...vulnerabilitiesBySeverityLabeling,
      },
      VulnerabilityAgeByCVSS: {
        description: '重点显示了您环境中按 CVSS 分数排列的漏洞发现时间的卡片',
        name: '按 CVSS 分数划分的漏洞发现日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityDiscoveryDateBySeverity: {
        description: '重点显示了您环境中按严重性排列的漏洞发现时间的卡片',
        name: '按严重性划分的漏洞发现日期',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishAgeBySeverity: {
        description: '按严重性详细说明了在您的环境中漏洞的发布寿命',
        name: '按严重性划分的漏洞发布寿命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishDateByCVSS: {
        description: '按 CVSS 分数列出的漏洞发布日期的卡片',
        name: '按 CVSS 分数划分的漏洞发布寿命',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      'petya-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title) 可遭 Petya 入侵',
        name: '可遭 Petya 入侵的 $t(assetsByComponent.OS.title)',
        summary: '我的__percent__资产正在运行__os__操作系统',
        value: '我的__percent__ (__value__) 资产正在运行__os__操作系统',
      },
      'petya-AssetsCriticalVuln': {
        description: '在您的环境中含有 Petya 漏洞的资产数量',
        label: {assetCount: '$t(assets)'},
        name: '含有 Petya 漏洞的资产',
        summary: {assetCount: '含有 Petya 漏洞'},
      },
      'petya-MostCommonExploitsComponent': {
        description:
          '在您的环境中针对 Petya 的$t(cards.mostCommonExploits.title)',
        name: '针对 Petya 的 $t(cards.mostCommonExploits.title)',
      },
      'petya-MostCommonVulnComponent': {
        description: '您的环境中最常见的 Petya 漏洞。',
        name: '最常见的 Petya 漏洞',
      },
      'petya-TotalVulnerabilities': {
        description: '在您的环境中发现的 Petya 漏洞数量。',
        label: {count: '发现的 Petya 漏洞'},
        name: 'Petya 漏洞计数',
        summary: {count: ''},
      },
      'samba-AssetsByOS': {
        description:
          '在您的环境中发现 $t(cards.assets.card.byOS.title) $t(sambaWithCve)',
        name: '$t(cards.assets.card.byOS.title) $t(sambaWithCve)',
        summary: '我的__percent__资产正在运行__os__操作系统',
        value: '我的__percent__ (__value__) 资产正在运行__os__操作系统',
      },
      'samba-ChangeInNumberOfAssets': {
        description: '可遭 $t(samba) 入侵的资产',
        label: {
          totalAssets: '可遭 Samba 入侵的资产',
        },
        name: '资产 $t(sambaWithCve)',
        summary: {
          assetCount: '增加__value__ (__percent__) ',
        },
      },
      'samba-MostCommonExploitsComponent': {
        description:
          '针对 $t(sambaWithCve) 的 $t(cards.mostCommonExploits.title)',
        name: '$t(cards.mostCommonExploits.title) for $t(samba)',
      },
      'samba-TopRiskiestAssetsComponent': {
        description:
          '可遭 $t(samba) 入侵的 $t(cards.TopRiskiestAssetsComponent.name)',
        name:
          '$t(cardTemplates.TopRiskiestAssetsComponent.name) $t(sambaWithCve)',
      },
      'samba-TotalVulnerabilities': {
        description: '在您的环境中发现的 $t(samba) 数量',
        label: {count: '$t(samba) $t(vulnerabilities)'},
        name: '发现的 $t(samba) 数量',
        summary: {count: ''},
      },
      'wannacry-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title) 可遭 WannaCry 入侵',
        name: '可遭 WannaCry 入侵的 $t(assetsByComponent.OS.title)',
        summary: '我的__percent__资产正在运行__os__操作系统',
        value: '我的__percent__ (__value__) 资产正在运行__os__操作系统',
      },
      'wannacry-AssetsCriticalVuln': {
        description: '在您的环境中含有 WannaCry 漏洞的资产数量',
        label: {assetCount: '$t(assets)'},
        name: '含有 WannaCry 漏洞的资产',
        summary: {assetCount: '含有 WannaCry 漏洞'},
      },
      'wannacry-MostCommonExploitsComponent': {
        description:
          '在您的环境中针对 WannaCry 的$t(cards.mostCommonExploits.title)',
        name: '针对 WannaCry 的 $t(cards.mostCommonExploits.title)',
      },
      'wannacry-MostCommonVulnComponent': {
        description: '在您的环境中最常见的 WannaCry 漏洞',
        name: '最常见的 WannaCry 漏洞',
      },
      'wannacry-TotalVulnerabilities': {
        description: '在您的环境中发现的 WannaCry 漏洞数量。',
        label: {count: '发现的 WannaCry 漏洞'},
        name: 'WannaCry 漏洞计数',
        summary: {count: ''},
      },
    },
    cards: {
      assets: {
        card: {
          agents: {
            byOS: {
              description: '含有按操作系统划分且已连接代理的资产分解的卡片。',
              summary: '我的已连接代理的资产正在运行__os__操作系统',
              title: '按操作系统划分的已连接代理的资产',
            },
            comingSoon: '即将推出',
            couldNotDownload: '下载代理软件时出错。',
            downloadBtnLoading: '正在下载：',
            downloadLinuxText: '下载 Linux 代理',
            downloadMacText: '下载 Mac 代理',
            downloadPageCategory: '代理管理',
            downloadPageTitle: '代理下载和管理页面',
            downloadWindowsText: '下载 Windows 代理',
            featureOne: {
              desc: 'Rapid7 代理与其他 Rapid7 产品集成。',
              number: '1',
              title: '一个代理控制全部',
            },
            featureThree: {
              desc: '代理的设计轻便灵活，您的用户绝不会注意到它。',
              number: '3',
              title: '占用空间有限',
            },
            featureTwo: {
              desc: '每当用户在线时，即可获取开箱即用且同步的有意义数据。',
              number: '2',
              title: '仅在您需要时提供数据',
            },
            installInstructions: {
              installation: '用于安装',
              installsTo: '代理安装至：',
              linux: {
                install: './agent_installer.sh install_start',
                installsTo1: '/opt/rapid7/ir_agent/',
                installsTo2:
                  '可通过平台的 SCM（systemctl、systemd 等）或通过安装程序控制代理：',
                installsTo3: './agent_installer.sh status',
                uninstall: './agent_installer.sh uninstall',
              },
              localInstallation: '用于本地安装',
              mac: {
                install: '双击 .pkg，浏览 UI 安装程序。',
                installsTo: '/opt/rapid7/ir_agent/',
                installsTo2:
                  '可通过 launchctl 将代理作为 com.rapid7.ir_agent 进行控制。',
                silentInstall: 'sudo installer -pkg <.pkg> -target /',
                uninstall: 'sudo /opt/rapid7/ir_agent/uninstall.sh -f',
              },
              multipleInstallations: '用于多次安装',
              silentInstall: '用于无提示安装',
              silentLocalInstall: '用于无提示本地安装',
              uninstall: '用于卸载',
              win: {
                installsTo: 'C:\\Program Files\\Rapid7\\Endpoint Agent\\',
                installsTo2: '可利用‘Rapid7 端点代理’服务控制代理。',
                local: '双击 .msi，浏览 UI 安装程序。',
                multiple:
                  '如要将代理安装至多个资产中，可使用端点管理工具，例如 System Center Configuration Manager（系统中心配置管理器，SCM）。如要使用组政策对象 (GPO)，请将 MSI 安装程序置于 Network Logon Share（网络登录分享）（活动目录）中。创建一个新 GPO。',
                silentLocal: 'msiexec /i agentinstaller-x86_x64.msi /quiet /qn',
              },
            },
            linuxAgent: 'Linux 代理',
            macAgent: 'Mac 代理',
            numberConnected: {
              description: '显示在您的环境中已连接代理的资产数量的卡片。',
              subTitle: '资产',
              summary: '含有已连接代理',
              title: '已连接代理的资产数量',
            },
            supportText:
              '需要帮助？ 请联系<a class="support-link">客户支持部门</a>。',
            winAgent: 'Windows 代理',
          },
          byLastScanDate: {
            description: '显示一份按资产最近扫描的方式分组的资产图表。',
            scanDateIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: '的我的资产在 __days__ 天内未扫描。',
            title: '按最后扫描日期划分的资产',
            totalAssets: '已扫描的资产',
          },
          byOS: {
            description: '含有按操作系统划分的资产分解的卡片。',
            summary: '的我的资产正在运行 __os__ 操作系统',
            title: '按操作系统划分的资产',
            unknownOS: '未知操作系统',
          },
          byRiskDelta: {
            description: '重点显示了在您的环境中风险评分增加最多的资产的卡片。',
            title: '按 30 天风险增加量划分的资产',
          },
          bySkillLevel: {
            description:
              '显示您环境中的资产分解，按利用资产漏洞所需的技能级别划分。',
            expertSummary: '的您环境中的资产可能被专家利用',
            intermediateSummary: '的您环境中的资产可能被中间人利用',
            legend: {
              expert: '专家',
              intermediate: '中间人',
              novice: '新手',
              unknown: '无已知的漏洞利用程序',
            },
            noviceSummary: '的您环境中的资产可能被新手利用',
            title: '按技能级别划分的可利用资产',
            unknownSummary: '的您环境中的资产没有已知的漏洞利用程序',
          },
          byTotalScanTime: {
            description: '显示按扫描时间分组的资产图表。',
            scannedIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: '的我的资产需要 __mins__ 分钟完成扫描。',
            title: '按总扫描时间划分的资产',
            totalAssets: '已扫描的资产',
            totalScanTime: '总扫描时间',
          },
          byVulnSeverity: {
            criticalSummary: '的我的资产有高危漏洞',
            description: '显示存在按严重性分组的漏洞的资产',
            legend: {
              critical: '高危漏洞',
              moderate: '低危漏洞',
              severe: '中危漏洞',
              unknown: '未知漏洞',
            },
            moderateSummary: '的我的资产有低危漏洞',
            severeSummary: '的我的资产有中危漏洞',
            title: '按漏洞严重性划分的资产',
            unknownSummary: '的我的资产未检测到已知的漏洞',
          },
          changeInNumber: {
            description:
              '显示资产的总数，以及该数字如何在指定的时间段内变化，便于您可以监控关键绩效指标。',
            subTitle: '总资产',
            summary: ' __difference__（__percentDifference__% 变化）',
            title: '总资产趋势',
          },
          defaultAccountVulns: {
            description: '显示漏洞与使用默认账户相关的资产数量。',
            subTitle: '资产',
            summary: '带有默认账户漏洞',
            title: '带有默认账户漏洞的资产',
          },
          knownObsoleteOS: {
            description: '目前正在运行已知淘汰的操作系统的资产百分比。',
            subTitle: '运行已淘汰操作系统的资产',
            title: '运行已淘汰操作系统的资产',
          },
          notScanned: {
            description: '显示未在指定的时间段内扫描的资产数量。',
            subTitle: '资产',
            summary: '未扫描',
            title: '未在最近扫描的资产',
          },
          owners: {
            violatingPolicy: {
              description: '违反公司政策数量最多的资产拥有者。',
              title: '违反公司政策的主要资产拥有者',
            },
          },
          violatingPolicy: {
            description: '违反公司政策数量最多的资产位置。',
            title: '违反公司政策的主要资产位置',
          },
        },
        description: '列出在您的环境中风险最高的资产。',
        donutTitle: '风险最高的资产',
        drilldown: {
          remediation: {
            assigneesPlaceholder: '将项目分配到...',
            clickHereToViewNewProject: '点击此处，以查看您的新项目。',
            createDynamicProject: '创建动态修复项目',
            createDynamicProjectHint: '创建按过滤器定义的新项目',
            createStaticProject: '创建静态修复项目',
            createStaticProjectHint: '添加选中的资产，以创建静态项目',
            descriptionPlaceholder: '项目描述',
            errorNotification: '保存您的修复项目时出错，请稍后重试。',
            manageProjects: '管理项目',
            remediate: '修复',
            selectedCount: '__count__ 个记录已选中。',
            successNotification: '已成功创建修复项目 __title__。__link__。',
            titlePlaceholder: '项目的名称',
            titleRequired: '标题不能为空',
          },
        },
        newlyDiscovered: {
          description: '显示在指定时间框架内在环境中新发现的资产的数量。',
          subTitle: '资产',
          summary: '新发现的',
          title: '新发现的资产',
        },
        title: '风险最高的主要资产',
        vulnerabilities: {
          critical: {
            description:
              '显示带有非预计高危风险漏洞（CVSS 分数超过 8）的资产的数量。',
            subTitle: '资产',
            summary: '带有高危漏洞',
            title: '带有高危风险漏洞的资产',
          },
          dataFetchFailed: '检索漏洞失败，请稍后重试。',
          nonCritical: {
            summary: '的我的资产有非高危风险漏洞',
          },
        },
      },
      counts: {
        assetGroupsCount: '资产组',
        assetSitesCount: '场所',
        assetTagsCount: '标签',
      },
      credential: {
        'success-over-time': '随着时间推移的凭证登录成功',
        successCard: {
          chart: {
            credentialFailedAssetCount: '的我的资产登录失败',
            credentialSuccessAssetCount: '的我的资产登录成功',
            credentialUnknownAssetCount: '的我的资产未尝试登录',
            legend: {
              credentialFailedAssetCount: '登录失败',
              credentialSuccessAssetCount: '登录成功',
              credentialUnknownAssetCount: '未尝试登录',
            },
          },
          description: '详细说明了在网络内凭证登录成功/失败比的卡片。',
          summary: {
            credentialFailedAssetCount: '的我的资产登录失败',
            credentialSuccessAssetCount: '的我的资产曾登录成功',
            credentialUnknownAssetCount: '的我的资产未尝试登录',
          },
          title: '资产的认证状态',
        },
      },
      'credential-success': {
        description: '显示认证成功的资产。',
        name: '按认证状态划分的资产',
      },
      'credential-success-over-time': {
        description:
          '显示了关于资产凭证随着时间推移成功或失败的信息和图表的卡片',
        name: '随着时间推移的凭证登录成功',
      },
      expired: {
        ssl: {
          certificatesCard: {
            description: '显示在您的环境中当前拥有过期 SSL 证书的资产的数量。',
            subTitle: '资产',
            summary: '带有过期 SSL 证书',
            title: '带有过期 SSL 证书的资产',
          },
        },
      },
      expiredVulnException: {
        description: '显示了在您的环境中最近过期的漏洞例外情况的卡片。',
        title: '最近到期的漏洞例外情况',
      },
      expiring: {
        ssl: {
          certificatesCard: {
            description:
              '显示在您的环境中 SSL 证书将要在指定时间框架内到期的资产的数量。',
            subTitle: '资产',
            summary: '带有即将过期的 SSL 证书',
            title: '带有即将过期的 SSL 证书的资产',
          },
        },
      },
      expiringVulnException: {
        description: '显示了在您的环境中即将过期的漏洞例外情况的卡片。',
        title: '漏洞例外情况即将到期',
      },
      exploitableVulnByCVSSScore: {
        description:
          '按 CVSS 分数分解您环境中可利用的漏洞百分比，以便您可以根据一般标准了解您环境中哪部分的风险较高。',
        legend: '__from__-__to__',
        summary: '的可利用漏洞的 CVSS 分数范围是 __from__ 到 __to__',
        title: '按 CVSS 分数划分的可利用漏洞',
      },
      location: {
        description: '列出在您的环境中总风险最高的位置。',
        title: '风险最高的主要资产位置',
      },
      mostCommonExploitableVuln: {
        description: '根据受影响的资产数显示在您的环境中最常见漏洞的卡片。',
        title: '最常见的可利用漏洞',
      },
      mostCommonExploits: {
        description: '根据受影响的资产数显示在您的环境中最常见的漏洞利用程序。',
        title: '最常见的漏洞利用程序',
      },
      mostCommonMalwareKits: {
        description: '根据受影响的资产数显示在您的环境中最常见的恶意软件包。',
        title: '最常见的恶意软件包',
      },
      mostCommonVuln: {
        description: '根据受影响的资产数显示在您的环境中最常见漏洞的卡片。',
        title: '最常见的漏洞',
      },
      obsolete: {
        osCard: {
          chart: {
            assetCount: '已淘汰操作系统资产',
            totalAssets: '剩余资产',
          },
          description: '目前正在运行已知淘汰的操作系统的资产百分比。',
          summary: {
            nonObsolete: '的运行未淘汰操作系统的资产',
            obsolete: '的运行已淘汰操作系统的资产',
          },
          title: '运行已淘汰操作系统的资产',
        },
        softwareCard: {
          chart: {
            assetCount: '已淘汰软件资产',
            totalAssets: '剩余资产',
          },
          description: '详细描述了网络内已淘汰/未淘汰资产的卡片。',
          summary: {
            nonObsolete: '的资产未安装已知的淘汰软件',
            obsolete: '的资产安装了已知的淘汰软件',
          },
          title: '运行已淘汰软件的资产',
        },
      },
      owner: {
        description: '列出资产总风险最高的资产拥有者。',
        title: '风险最高的主要资产拥有者',
      },
      projectsAtRisk: {
        description: '显示即将到期但仍处于开启状态的项目数量。',
        subTitle: '正在关闭项目',
        summary: '',
        title: '存在风险的项目',
      },
      projectsMostRemainingWork: {
        description: '列出含有未解决修复项目数量最多的项目。',
        title: '剩余工作',
      },
      projectsMostRemainingWorkPercent: {
        description: '列出含有未解决修复项目数量最多的项目。',
        title: '剩余工作 %',
      },
      projectsPastDue: {
        description: '显示过期项目的数量。',
        subTitle: '项目',
        summary: '已过期',
        title: '过期项目',
      },
      projectsRecentlyClosed: {
        description: '显示近期关闭的项目数量。',
        subTitle: '已关闭项目',
        summary: '',
        title: '近期关闭的项目',
      },
      remediatedVulnerabilities: {
        description: '列出在您的环境中在过去 30 天内数量减少的漏洞。',
        title: '已修复的主要漏洞',
      },
      remediationProgressCard: {
        assignees: {
          all: '所有受让人',
          email: '电子邮件',
        },
        confirm: '确认',
        dates: {
          all: '所有时间',
          custom: '自定义',
          lastMonth: '上个月',
          lastWeek: '上周',
          thisMonth: '本月',
          thisWeek: '本周',
        },
        endDate: '结束日期',
        noProjectsCreated: '还未创建项目',
        progress: '进程',
        projectStatus: {
          complete: '完成',
          completed: '已完成',
          inProgress: '正在进行',
          incomplete: '未完成',
          notStarted: '未开始',
        },
        projects: '项目',
        recentProjects: '最近项目',
        startDate: '开始日期',
        task: '任务',
        title: '修复项目进程',
      },
      remediatorsRequiringAssistance: {
        description: '列出包含依然开启、但已过期项目数量最多的项目拥有者。',
        title: '需要协助的修复人员',
      },
      'risk-vulns-card': {
        description: '显示按风险和漏洞数量排序的资产散点图',
        name: '按风险和漏洞划分的资产',
      },
      riskOverTimeCard: {
        allTime: '所有时间',
        custom: '自定义',
        riskScore: '风险评分',
        thisMonth: '本月',
        thisWeek: '本周',
        time: '时间',
        title: '随着时间推移的风险',
      },
      riskVsVulnerabilities: {
        hostname: '主机名称：__name__',
        ipAddress: 'IP 地址',
        riskScore: '风险评分',
        title: '按风险和漏洞划分的资产',
        vulnerabilities: '漏洞',
      },
      'scan-card': {
        description:
          '显示您环境中所有扫描的摘要，包括失败的、暂停的和完成的扫描数量',
        name: '扫描',
      },
      scanCard: {
        complete: '完成',
        drilldownTitle: '扫描',
        failed: '已失败',
        inProgress: '正在进行',
        paused: '暂停',
        subTitle: '过去 30 天',
        table: {
          assets: '资产',
          siteName: '场所名称',
          startDate: '开始日期',
          status: '状态',
          vulnerabilities: '漏洞',
        },
        title: '扫描',
      },
      sites: {
        riskiest: '风险最高的场所',
        title: '风险最高的主要场所',
      },
      'top-riskiest-asset-groups': {
        description: '列出在您的环境中风险评分最高的资产组。',
        name: '风险最高的主要资产组',
      },
      'top-riskiest-assets': {
        description: '列出在您的环境中风险最高的资产。',
        name: '风险最高的主要资产',
      },
      'top-riskiest-sites': {
        description: '列出在您的环境中总风险最高的场所。',
        name: '风险最高的主要场所',
      },
      topRemediators: {
        description: '列出含有成功按时关闭的项目数量最多的项目拥有者。',
        title: '最主要的修复人员',
      },
      trendingVulnerabilities: {
        description: '列出在您的环境中在过去 30 天内数量增加的漏洞。',
        title: '趋势最明显的主要漏洞',
      },
      vulnByCVSSScore: {
        description:
          '按 CVSS 分数分解您环境中的漏洞百分比，以便您可以根据一般标准了解您环境中的哪部分的风险较高。',
        legend: '__from__-__to__',
        summary: '的漏洞的 CVSS 分数范围是 __from__ 到 __to__',
        title: '按 CVSS 分数划分的漏洞',
      },
      vulnByRiskScore: {
        description: '按风险评分显示我的环境中所有漏洞的百分比的卡片。',
        legend: '__from__-__to__',
        summary: '的漏洞的风险评分范围是 __from__ 到 __to__',
        summaryOver900: '的漏洞的风险评分超过 900',
        title: '按风险评分划分的漏洞',
      },
      vulnerabilities: {
        ageByCVSS: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            'cvss-range-1': '0.1-3.9',
            'cvss-range-2': '4.0-6.9',
            'cvss-range-3': '7.0-10',
          },
          description: '重点显示了您环境中按 CVSS 分数排列的漏洞发现时间的卡片',
          title: '按 CVSS 分数划分的漏洞发现日期',
        },
        ageBySeverity: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            critical: '高危',
            moderate: '低危',
            severe: '中危',
          },
          description: '显示了您的环境中按严重性划分的漏洞平均寿命的卡片',
          title: '按严重性划分的平均漏洞寿命',
        },
        bySkillLevel: {
          description: '显示您环境中的漏洞分解，按利用它们所需的技能级别划分。',
          expertSummary: '的漏洞可能被专家利用',
          intermediateSummary: '的漏洞可能被中间人利用',
          legend: {
            expert: '专家',
            intermediate: '中间人',
            novice: '新手',
            unknown: '无已知的漏洞利用程序',
          },
          noviceSummary: '的漏洞可能被新手利用',
          title: '按技能级别划分的可利用漏洞',
          unknownSummary: '的您环境中的漏洞无已知的漏洞利用程序',
        },
        bySkillLevelOverTime: {
          description: '按严重性显示您的环境中随时间推移的所有漏洞的卡片。',
          title: '按随着时间推移的技能级别划分的可利用漏洞',
        },
        byVulnSeverity: {
          criticalSummary: '的您的漏洞为高危',
          description: '按严重性级别显示您环境中的漏洞百分比分解。',
          legend: {
            critical: '高危漏洞',
            moderate: '低危漏洞',
            severe: '中危漏洞',
            unknown: '未知',
          },
          moderateSummary: '的您的漏洞为低危',
          severeSummary: '的您的漏洞为中危',
          title: '按严重性划分的漏洞',
        },
        card: {
          exploitable: {
            description:
              '显示您的环境中漏洞总数量以及该数量在指定的时间段内如何变化的卡片。',
            subTitle: '可利用的漏洞',
            title: '可利用的漏洞计数',
          },
          totalNumber: {
            description:
              '显示了在您的环境中在一段指定时间内漏洞数量变化的卡片。',
            subTitle: '漏洞总数',
            summary: ' __difference__（__percentDifference__% 变化）',
            title: '漏洞数',
          },
        },
        detail: {
          entity: {
            cvssScore: 'CVSS',
            dateModified: '已修改',
            datePublished: '已发布',
            severity: '严重性',
            title: '标题',
            vulnId: '漏洞 ID',
          },
          title: '漏洞信息',
          vulnInstances: {
            dataFetchFailed: '检索漏洞实例失败。',
          },
        },
        discoveryByTotalRiskScore: {
          description:
            '显示在过去 90 天内发现的漏洞，按总风险评分从高至低分类。',
          title: '按总风险评分划分的新发现漏洞',
        },
        discoveryDateBySeverity: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            critical: '高危',
            moderate: '低危',
            severe: '中危',
          },
          description: '重点显示了您环境中按严重性排列的漏洞发现时间的卡片',
          title: '按严重性划分的漏洞发现日期',
        },
        exploitable: {
          ageByCVSS: {
            description:
              '重点显示了您环境中按 CVSS 分数排列的可利用漏洞发现时间的卡片',
            title: '按 CVSS 分数划分的可利用漏洞发现日期',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
          ageBySeverity: {
            description:
              '显示了在您的环境中按严重性划分的可利用漏洞平均寿命的卡片',
            title: '按严重性划分的可利用漏洞发布寿命',
          },
          byVulnSeverity: {
            criticalSummary: '的您的可利用漏洞为高危',
            description: '按严重性级别显示您环境中可利用漏洞的百分比分解。',
            legend: {
              critical: '可利用的高危漏洞',
              moderate: '可利用的低危漏洞',
              severe: '可利用的中危漏洞',
              unknown: '未知',
            },
            moderateSummary: '的您的可利用漏洞为低危',
            severeSummary: '的您的可利用漏洞为中危',
            title: '按严重性划分的可利用漏洞',
          },
          discoveryByTotalRiskScore: {
            description:
              '显示在过去 90 天内发现的可利用漏洞，按总风险评分从高至低分类。',
            title: '按总风险评分划分的新发现的可利用漏洞',
          },
          discoveryDateBySeverity: {
            description:
              '重点显示了您环境中按严重性排列的可利用漏洞发现时间的卡片',
            title: '按严重性划分的可利用漏洞发现日期',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishAgeBySeverity: {
            description:
              '按严重性详细说明了在您的环境中可利用漏洞发布寿命的卡片',
            title: '按严重性划分的可利用漏洞发布寿命',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishDateByCVSS: {
            description: '按 CVSS 分数列出的可利用漏洞发布日期的卡片',
            title: '按 CVSS 分数划分的可利用漏洞发布寿命',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
        },
        introducedLastWeek: {
          description: '按风险评分显示在上周进入您的网络内的新漏洞。',
          title: '按风险评分划分的新漏洞',
        },
        publishAgeBySeverity: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            critical: '高危',
            moderate: '低危',
            severe: '中危',
          },
          description: '按严重性详细说明了在您的环境中漏洞的发布寿命',
          title: '按严重性划分的漏洞发布寿命',
        },
        publishDateByCVSS: {
          categories: {
            'age-range-1': '0-29 天',
            'age-range-2': '30-59 天',
            'age-range-3': '60-90 天',
            'age-range-4': '> 90 天',
            'cvss-range-1': '0.1-3.9',
            'cvss-range-2': '4.0-6.9',
            'cvss-range-3': '7.0-10',
          },
          description: '按 CVSS 分数列出的漏洞发布日期的卡片',
          title: '按 CVSS 分数划分的漏洞发布寿命',
        },
        remediated: {
          description: '显示您的网络内对风险评分作用最大的修复列表的卡片。',
          title: '按风险评分划分的最近完成的修复',
        },
        riskScoreOverTime: {
          cardTitle: '随着时间推移的漏洞风险评分',
          description:
            '显示环境内的漏洞风险趋势，便于您了解总风险随着时间推移是否增加或下降。',
          name: '随着时间推移的漏洞风险评分',
        },
      },
    },
    cardsLabel: '卡片',
    category: '类别',
    certainity: '确定性',
    certainty: '确定性',
    chart: {
      loading: '正在加载图表。',
      noData: '没有足够的数据来显示此图表。',
    },
    class: '类别',
    close: '关闭',
    closed: '关闭',
    comingSoon: '即将推出',
    comparison: {
      cancelText: '取消比较',
      compare: '比较',
      errorMessage: '请选择两个有效的比较日期。',
      failedDataFetch: '获取比较数据失败，请稍后重试。',
      fromDate: '开始日期',
      metricAdded: '添加 __name__',
      metricChange: '__name__ 改变',
      metricPrimarySubTitle: '在两个所选扫描中的总 __name__',
      metricRemediated: '已修复的__name__',
      metricUnchanged: '未改变的 __name__',
      text: '比较 - 比较两项扫描，了解有哪些变化',
      toDate: '至今',
    },
    configure: '配置',
    confirm: '确定',
    confirmLabel: '确认',
    'container-counts': {
      description: '显示资产容器计数的卡片',
      name: '计数',
    },
    continue: '继续',
    copy: '复制',
    count: '计数',
    cpe: 'CPE',
    createdOn: '创建日期',
    critical: '高危',
    cvss: 'CVSS',
    cvssScore: 'CVSS 分数',
    dashboard: {
      cannotBeEmpty: '仪表板名称不能为空',
      nameInUse: '此名称已在使用中',
      tooLong: '字符数已超出最大长度限制 __length__',
    },
    dashboardDescription: '$t(dashboardLabel) 描述',
    dashboardDropdown: {
      allMyDashboards: '我的所有仪表板',
      allTemplates: '在 R7 库中查看更多',
      createDashboard: '创建新仪表板',
      dashboardTemplates: 'Rapid7 推荐这些仪表板模板',
      myDashboards: '我的仪表板',
    },
    dashboardLabel: '仪表板',
    dashboardLibrary: {
      categoryName: {
        allMyDashboards: '$t(dashboardDropdown.allMyDashboards)',
        allTemplates: '所有仪表板模板',
        asset: '资产模板',
        changed: '变更内容模板',
        executive: '执行模板',
        ownedDashboards: '由我拥有',
        scans: '扫描和运营模板',
        sharedDashboards: '与我共享',
        vulnerability: '漏洞模板',
      },
      dashboardTemplates: 'Rapid7 仪表板模板',
      myDashboards: '我的仪表板',
      templateDescription: {
        assets:
          '在资产仪表板上可查看资产、资产的属性和漏洞，以快速发现和了解最重要的资产及其在您的环境中的威胁曝光情况。',
        changed:
          '变更内容仪表板提供了高效的方式来确定变更的内容、新发现的资产和基线指标，帮助建立环境。',
        executive:
          '了解威胁曝光正在好转还是恶化。深入了解在获得投资回报方面的团队绩效和关键指标。',
        exploitableVulns:
          '在可利用漏洞仪表板上可查看与已知漏洞利用程序包或恶意软件相关的漏洞数据。',
        petya:
          '此仪表板中包含一组卡片，可让您即时发现存在的类似于 Petya 的勒索软件，此类软件在某种程度上利用漏洞进行传播 (MS17-010)。',
        remediations:
          '您可通过修复仪表板查看所执行的修复工作，从而帮助您专注于重要事项：项目存在风险，需要修复团队，甚或需要最出色的修复团队。',
        samba:
          '此仪表板中包含一组卡片，可让您实时发现特定高危漏洞：Samba (CVE-2017-7494)。对这些卡片进行自定义过滤，以报告组织中与此漏洞相关的安全态势。',
        threatFeed:
          '在威胁来源仪表板上可查看漏洞数据，这些数据具有高度可利用性，且可通过 Rapid7 威胁来源的源头执行主动追踪和加以利用。',
        vulnerabilities:
          '在漏洞仪表板上可查看漏洞的存在情况和性质，便于您了解在所处环境中需要采取的下一步重要操作。',
        wannaCry:
          '此仪表板中包含一组卡片，可让您即时发现存在的类似于 WannaCry 的勒索软件，此类蠕虫软件通常利用漏洞进行传播 (CVE-2017-0144)。对这些卡片进行自定义过滤，以报告组织中与 WannaCry 相关的安全态势。',
      },
      templateName: {
        assets: '资产仪表板',
        changed: '变更内容仪表板',
        executive: '执行仪表板',
        exploitableVulns: '可利用漏洞仪表板',
        petya: '类似于 Petya 的勒索软件',
        remediations: '修复仪表板',
        samba: 'Samba',
        threatFeed: '威胁来源仪表板',
        vulnerabilities: '漏洞仪表板',
        wannaCry: 'WannaCry',
      },
    },
    dashboardLibraryLabel: '$t(dashboardLabel) 库',
    dashboardName: '$t(dashboardLabel) 名称',
    dashboardsFailed: '检索您的仪表板失败，请刷新后重试。',
    dashboardsSaveFailed: '警告：保存您的仪表板失败',
    databaseName: '数据库名称',
    databases: '数据库',
    date: '日期',
    days: '天',
    defaultDashboard: '默认仪表板',
    defaultDelete: '您不能删除默认仪表板',
    defaultNameChangeAlert: '您不能更改默认仪表板的名称！',
    delete: '删除',
    deleteDashboard: '确定要删除 ',
    deleteIconToolTip: '删除卡片',
    description: '描述',
    details: '详情',
    deviceClass: '设备类别',
    disabled: '已禁用',
    discoveredByConnection: '通过连接发现',
    discoveryDate: '发现日期',
    dismiss: '放弃',
    downloadAgent: '下载代理',
    downloadAgents: '下载代理',
    downloading: '正在下载',
    dueOn: '到期日',
    duplicate: '复制',
    duplicateDashboard: '$t(duplicate) $t(dashboardLabel)',
    duplicateWidgetTitle: '复制卡片',
    dynamic: '动态',
    edit: '编辑',
    edited: '已编辑',
    ellipses: '__phrase__...',
    enableLiveMonitoring: '启用实时监控',
    enabled: '已启用',
    error: '错误',
    exceptionScope: '例外情况范围',
    exceptions: '例外情况',
    expandCard: '扩展卡片',
    expirationTime: '到期时间',
    expiresOn: '到期时间',
    expiringOn: '将要到期时间',
    exploit: '漏洞利用程序',
    exploitCount: '漏洞利用程序数',
    exploitDB: '$t(exploit) DB',
    exploitRank: '排序',
    exploitRanks: {
      average: '平均值',
      excellent: '出色',
      good: '好',
      great: '极好',
      low: '低',
      manual: '手动',
      normal: '正常',
    },
    exploitableVulnerabilities: '可利用的漏洞',
    exploitableVulns: '$t(exploitableVulnerabilities)',
    exploits: '漏洞利用程序',
    exportToCSV: '导出至 CSV',
    exposure: '曝光',
    exposureValues: {
      common: '常见',
      favored: '受喜爱',
      occasional: '偶尔',
      popular: '流行',
      rare: '罕见',
      uncommon: '不常见',
      undefined: '未定义',
      unknown: '未知',
    },
    failed: '已失败',
    false: '假',
    family: '家族',
    fileName: '文件名',
    files: '文件',
    filesAndDirectories: '文件和目录',
    filter: {
      asset: {
        addressType: '地址类型',
        assetId: '资产 ID',
        assetKey: '资产唯一标识符',
        assetType: '资产类型',
        exploitCount: '漏洞利用程序计数',
        hostName: '$t(hostName)',
        ipAddress: 'IP 地址',
        mac: 'MAC 地址',
        malwareCount: '恶意软件计数',
        operatingSystem: '操作系统',
        riskScore: '风险评分',
        vulnerabilityCount: '漏洞计数',
      },
      'asset-group': {
        assets: '资产',
        groupId: '组 ID',
        groupName: '组名称',
        isDynamic: '是动态的',
        riskScore: '风险评分',
        vulnerabilities: '漏洞',
      },
      cardError: {
        actionableCardError:
          '加载卡片时出错。请<a class="action reload-card">重新加载</a>卡片或<a class="action delete-card">删除</a>卡片。',
        actionableFilterError:
          '由于相关过滤器出错，所以无法加载卡片。<a class="action reset-card">重设</a>为默认值或<a class="action delete-card">删除</a>此卡片',
        cardError:
          '加载卡片时出错，请重新加载卡片，或联系仪表板拥有者，重设或删除此卡片。',
        filterError:
          '由于相关过滤器出错，所以无法加载卡片。请联系仪表板拥有者，重设或移除此过滤器。',
      },
      filterName: '$t(filterLabel) 名称',
      filterText: '$t(filterLabel) 文本',
      management: {
        allFilter: '所有 $t(filters)',
        createError: '创建 $t(filterLabel) "__filterName__"时出错',
        createFilter: '创建 $t(filterLabel)',
        createSuccess: '成功创建 $t(filterLabel) "__filterName__"',
        deleteConfirmation:
          '删除某个过滤器将导致从相关联的任何卡片或项目中将其删除。您是否仍要删除？',
        deleteError: '删除选中的过滤器时出错。请稍后重试。',
        deleteError_plural: '删除选中的过滤器时出错。请稍后重试。',
        deleteSavedFilter: '删除已保存的过滤器',
        deleteSharedOnly:
          '由于所有过滤器均为共享过滤器，所以未删除任何过滤器。',
        deleteSuccess:
          '已删除 $t(filterLabel)，且同时还将从所使用的卡片中将其删除。',
        deleteSuccess_plural:
          '已删除__count__ $t(filters) 个过滤器，且同时还将从所使用的卡片中将这些过滤器删除。',
        duplicateFilter: '复制 $t(filterLabel)',
        editFilter: '编辑 $t(filterLabel)',
        saveError: '更新过滤器 "__filterName__" 时出错。请稍后重试。',
        saveSuccess: '成功创建 $t(filterLabel) "__filterName__"',
      },
      notFound: {
        actionableDescription:
          '此卡片拥有者已将应用至卡片的过滤器删除。<a class="action reset-card">重设为</a>默认值或<a class="action delete-card">删除</a>此卡片',
        description:
          '此卡片拥有者已将应用至卡片的过滤器删除。请联系仪表板拥有者，更新或移除此过滤器。',
      },
      os: {
        'attribute.deviceType': '设备类型',
        'attribute.operatingSystemDescription': '操作系统描述',
        'attribute.product': '产品',
        'attribute.productFamily': '产品家族',
        'attribute.productVendor': '产品供应商',
        'attribute.systemArchitecture': '系统架构',
        'attribute.version': '版本',
        count: '计数',
      },
      site: {
        assetCount: '资产计数',
        autoEngineSelectionEnabled: '引擎选择已启用',
        criticalVulnerabilityCount: '高危漏洞计数',
        dynamic: '动态',
        key: '密钥',
        moderateVulnerabilityCount: '低危漏洞计数',
        name: '名称',
        riskFactor: '风险因素',
        riskScore: '风险评分',
        riskScoreTimestamp: '风险评分时间戳',
        severeVulnerabilityCount: '中危漏洞计数',
        siteID: '场所 ID',
      },
    },
    filterLabel: '过滤器',
    filters: '过滤器',
    find: '查找',
    fingerprints: '指纹',
    firstFound: '已发现',
    fix: '修复',
    groups: '组',
    hardware: '硬件',
    hostName: '主机名称',
    hostNames: '主机名称',
    hostType: '主机类型',
    id: 'ID',
    installedSoftware: '已安装软件',
    instanceCount: '实例',
    instances: '实例',
    ipAddress: 'IP 地址',
    ipAddresses: 'IP 地址',
    kpi: 'KPI',
    labels: {
      assetGroups: '资产组',
    },
    lastOnline: '上一次在线',
    lastScan: '上一次扫描',
    learnMore: '了解更多',
    list: {
      loading: '正在加载列表数据。',
    },
    liveAssessmentDescription:
      '代理程序是实时评估和监视<br>程序的重要组件。代理程序可收集关于远程资产的信息,使您能够<br>追踪更多资产，而无需增添扫描。',
    loadingIssueTypes: '加载问题类型',
    location: '位置',
    macAddress: 'MAC 地址',
    macAddresses: 'MAC 地址',
    malware: '恶意软件',
    malwareCount: '恶意软件计数',
    malwareKit: '恶意软件包',
    malwareKits: '恶意软件包',
    manage: '管理',
    me: '我',
    metasploit: 'Metasploit',
    minutes: '分钟',
    moderate: '低危',
    modifiedDate: '修改于',
    modifiedOn: '修改于',
    name: '名称',
    nameIsRequired: '名称不能为空',
    newInstances: '新实例',
    next: '下一步',
    next6months: '在未来 6 个月',
    next7days: '在未来 7 天',
    next30days: '在未来 30 天',
    next60days: '在未来 60 天',
    next90days: '在未来 90 天',
    nextScan: '下次扫描',
    nextYear: '在下一年',
    no: '否',
    noActiveExploitsAvailable: 'Rapid7 当前无法将此漏洞作为活动目标进行追踪。',
    noOfAssets: '资产数量',
    noOfAssetsAffected: '无受影响的资产',
    noOfInstances: '无实例',
    noRecords: '未找到记录。',
    noWidgets: '未选中卡片。',
    numberOfNumber: ' __divisor__的__dividend__',
    offline: '离线',
    online: '在线',
    onlineSince: '在线起始时间',
    open: '打开',
    operatingSystem: '操作系统',
    operatingSystems: '操作系统',
    optional: '可选项',
    originalRiskScore: '初始风险评分',
    os: {
      products: '__vendor__产品',
      versions: '__vendor__ __product__ 版本',
    },
    osLabel: '操作系统',
    other: '其他',
    overview: '概述',
    owner: '拥有者',
    password: '密码',
    past2weeks: '在过去 2 周',
    past6months: '在过去 6 个月',
    past7days: '在过去 7 天',
    past30days: '在过去 30 天',
    past60days: '在过去 60 天',
    past90days: '在过去 90 天',
    pastDue: '已过期',
    pastMonth: '在上个月',
    pastWeek: '在上周',
    pastYear: '在去年',
    percent: '__percent__$t(percentageSymbol)',
    percentLabel: '百分比',
    percentOfAssets: '$t(percentageSymbol) 的资产',
    percentageSymbol: '%',
    petya: 'Petya',
    policies: '政策',
    policyElement: '政策要素',
    policyName: '政策名称',
    policyTitle: '政策标题',
    port: '端口',
    previous: '上一步',
    product: '产品',
    program: '程序',
    projects: '项目',
    proof: '证明',
    protocol: '协议',
    publishDate: 'P发布于',
    publishedOn: '发布于',
    queryBuilder: {
      alternateIds: {
        altId: '替代 id 的 id',
        size: '替代 id 的数量',
        source: '替代 id 来源',
        title: '漏洞的替代 id 集合',
      },
      asset: {
        agentKey: '代理密钥',
        altips: {
          name: '替代 ip 集合',
          size: '替代 ip 的数量',
        },
        altmacs: {
          name: '替代 mac 集合',
          size: '替代 mac 的数量',
        },
        altnames: {
          name: '替代名称集合',
          size: '替代名称的数量',
        },
        assetKey: '资产密钥',
        averageScanDuration: '平均扫描持续时间',
        console: '主控制台',
        credentialSuccessStatus: '指示已成功或失败的状态',
        endpoints: {
          certainty: 'fp 的端点确定性',
          name: '端点服务名称',
          port: '端点端口',
          protocol: '端点协议',
          size: '端点的数量',
          title: '端点集合',
        },
        firstScanTime: '首个资产扫描日期',
        groups: '组名称集合',
        ipv4: '资产的主要 ipv4',
        ipv6: '资产的主要 ipv6',
        lastAgentConnectionTime: '代理上一次连接的日期和时间。',
        lastScanDuration: '最近的扫描持续时间',
        lastScanTime: '最近的资产扫描日期',
        mac: '资产的主要 mac',
        name: '资产的主机名称',
        os: {
          arch: '资产操作系统架构',
          description: '资产操作系统描述',
          family: '资产操作系统家族',
          product: '资产操作系统产品',
          title: '主要资产操作系统对象',
          type: '资产操作系统类型',
          vendor: '资产操作系统供应商',
          version: '资产操作系统版本',
        },
        riskScore: '资产风险评分',
        sites: '场所名称集合',
        software: {
          description: '软件说明',
          family: '软件家族',
          product: '软件产品',
          program: '软件程序',
          size: '已安装软件的数量',
          title: '软件对象集合',
          vendor: '软件供应商',
          version: '软件版本',
        },
        sslCertificateMinimumExpirationDate: 'ssl 证书过期',
        tags: {
          name: '标签名称',
          type: '标签类型',
        },
        type: '资产的主机类型',
      },
      assetgroup: {
        assets: {
          description: '组内资产',
          size: '组内的资产数量',
        },
        dynamic: '指示静态或动态',
        groupKey: '组的唯一 ID',
        name: '资产组的名称',
        riskScore: '组的风险评分',
        vulnCount: '漏洞的数量',
      },
      exploits: {
        description: '漏洞利用程序描述',
        exploitRank: '漏洞利用程序排名',
        id: '漏洞利用程序 id',
        name: '漏洞利用程序名称',
        rank: '漏洞利用程序排名',
        size: '该漏洞的漏洞利用程序数量',
        source: '漏洞利用程序来源',
        title: '漏洞归属的漏洞利用程序集合',
      },
      help: {
        title: '句法帮助/查询字典',
      },
      nameIsRequired: '$t(nameIsRequired)',
      placeholder: '点击以创建新过滤器',
      saveFilter: {
        placeholder: '保存过滤器',
        title: '保存过滤器',
      },
      selectSavedQuery: '选择保存的查询',
      site: {
        assets: {
          description: '场所内资产',
          size: '场所内资产数量',
        },
        autoEngineSelected: '指示自动引擎状态',
        dynamic: '指示静态或动态',
        name: '场所的名称',
        riskFactor: '场所的风险因素',
        riskScore: '场所的风险评分',
        siteKey: '场所的唯一标识符',
        status: '场所状态',
        vulnCount: '场所内漏洞的数量',
      },
      solution: {
        fix: '特定漏洞的解决方案修复',
        solutionKey: '特定漏洞的解决方案密钥',
        summary: '特定漏洞的解决方案摘要',
      },
      tag: {
        assets: {
          description: '标签内的资产',
          size: '标签内的资产数量',
        },
        groups: {
          description: '标签内的组',
          size: '标签内的组数量',
        },
        name: '标签名称',
        riskModifierAttribute: '标签的风险修饰符',
        sites: {
          description: '标签内的场所',
          size: '标签内的场所数量',
        },
        sourceAttribute: '标签的来源属性',
        tagKey: '标签的唯一标识符',
        type: '标签的类型',
      },
      type: {
        IP: 'IP 地址',
        boolean: '布尔',
        date: '日期',
        duration: '持续时间',
        object: '对象',
        objectCollection: '对象集合',
        standardNumber: '数量',
        standardString: '字符串',
        stringCollection: '字符串集合',
      },
      vulnerability: {
        assetKey: '资产密钥',
        categories: {
          size: '类别数量',
          title: '漏洞归属的类别',
        },
        cveIds: '漏洞的 cve id 列表',
        cvssScore: '漏洞的 cvss 分数',
        dateModified: '漏洞最后一次修改的日期',
        datePublished: '漏洞发布的日期',
        description: '漏洞描述',
        malwareKits: {
          size: '恶意软件包数量',
          title: '与漏洞相关的恶意软件包',
        },
        object: '概述关于漏洞的事实',
        pciCompliant: '指示资产是否符合 PCI 要求',
        port: '漏洞端点端口',
        protocol: '漏洞端点协议',
        risk: '漏洞风险（如不重新扫描可能过期）',
        severity: '漏洞严重性',
        severityScore: '漏洞严重性评分数值',
        size: '漏洞数量',
        skillLevel: '漏洞技能级别',
        software: '软件的混合字符串 id',
        softwareFamily: '漏洞的软件家族',
        softwareProduct: '漏洞的软件产品',
        softwareVendor: '漏洞的软件供应商',
        softwareVersion: '漏洞的软件版本',
        title: '漏洞标题',
        vulnKey: '漏洞唯一标识符',
      },
      vulnerabilityexception: {
        asset: {
          ipv4: '应用了例外情况的资产的 ipv4',
          ipv6: '应用了例外情况的资产的 ipv6',
          key: '被定义为例外情况的资产的密钥',
          name: '应用了例外情况的资产的名称',
          size: '标签内的资产数量',
        },
        expirationTime: '例外情况的到期时间',
        port: '被定义为例外情况的端口',
        reason: '例外情况的原因',
        reasonDetails: '例外情况的原因细节',
        reviewerActionTime: '审查人的操作时间',
        reviewerKey: '审查人的密钥',
        reviewerReason: '审查人操作的原因',
        scope: '例外情况的范围',
        siteKey: '被定义为例外情况的场所的密钥',
        state: '例外情况的状态',
        submitterActionTime: '提交者的操作时间',
        submitterKey: '提交者的密钥',
        vulnExceptionKey: '漏洞例外情况唯一标识符',
      },
    },
    ra: {
      affectedAssets: '受影响资产',
      assignees: '受让人',
      description:
        '重点显示了您可以在网络中执行的修复，且这些修复将对减少总体风险评分产生最大影响的卡片。',
      project: {
        access: '访问',
        accessDescription: '允许无权访问此项目相关资产的用户进行查看',
        assetCountExceeded:
          '每个项目的资产限量是__maxAssets__。请细化您的查询。',
        assetFilter: '资产过滤器',
        assetSelectionExceeded:
          '静态项目的资产限量是 __maxAssets__。请取消选择一些资产，并重试。',
        cardAssetFilter: '卡片资产过滤器',
        cardVulnerabilityFilter: '卡片漏洞过滤器',
        chooseConnection: '选择项目连接',
        createProject: '创建修复项目',
        deleteError: '删除修复项目时出错。',
        deleteProjectConfirm: '是否确定要删除选中项目？',
        deleteProjectTitle: '确认删除项目',
        editProject: '编辑修复项目',
        entity: {
          assignees: '受让人',
          completedAssetsPercent: '% 资产已完成',
          completedRemediations: '已解决的解决方案',
          completedRemediationsPercent: '进程',
          createdOn: '$t(createdOn)',
          description: '描述',
          dueOnTime: '到期日',
          numAssets: '受影响的资产',
          ownerName: '拥有者',
          progress: '进程',
          remainingRemediations: '剩余修复',
          remainingTime: '剩余时间',
          remainingWork: '剩余工作',
          serverActive: '票证',
          status: '状态',
          title: '项目名称',
          totalRemediations: '修复总数',
          totalRisk: '累积风险',
          type: '类型',
        },
        filterPlaceholder: '点击以添加过滤器',
        minimumDate: '到期日必须为今日或之后的日期。',
        nameInUse: '此名称已在使用中',
        nameIsRequired: '$t(nameIsRequired)',
        overview: {
          title: '项目概述',
        },
        owner: {
          active: '$t(active)',
          email: '电子邮件',
          userFullName: '名称',
          userKey: '用户 ID',
          userName: '用户名',
        },
        ownerTitle: '项目拥有者',
        populatingNoRows:
          '未找到记录。如果是近期创建项目，则可能需要几分钟时间完全填充解决方案。',
        populatingWarning:
          '您的项目已创建，可能需要几分钟时间完全填充解决方案。',
        projectContent: '项目内容',
        status: {
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
        },
        ticketingConfigurationWarning: '您在此处所做选择稍后将无法更改。',
        type: {
          DYNAMIC: '动态',
          STATIC: '静态',
        },
        updateError: '$t(cards.assets.drilldown.remediation.errorNotification)',
        updateStatusError: '更新修复项目时出错。',
        updateToClosedStatus: '关闭选中的项目',
        updateToOpenStatus: '打开选中的项目',
        viewProject: '查看项目',
        vulnerabilityFilter: '漏洞过滤器',
      },
      projectError: {
        entity: {
          description: '描述',
          errorType: '错误码',
          timeOccurred: '错误日期',
        },
        errorsDescription: '修复项目的票证出错。请查看下方的错误详细信息',
        errorsHeader: '修复工作流__projectName__中的票证错误',
        message: {
          BAD_STATE:
            '失效状态 - __SERVER_NAME__服务器上无适用于修复状态 __REMEDIATION_STATUS__ 的映射',
          FAIL_COMMENT_1: '向问题__ISSUE_KEY__添加注释失败 - 中断或超时。',
          FAIL_COMMENT_2: '向问题__ISSUE_KEY__添加注释失败 - 执行错误。',
          FAIL_ISSUE_1: '获取问题__ISSUE_KEY__失败 - 中断或超时。',
          FAIL_ISSUE_2: '获取问题__ISSUE_KEY__失败 - 执行错误。',
          FAIL_STATUS_1:
            '获取问题__ISSUE_KEY__失败 - 中断或超时。因此，将无法同步修复状态：__REMEDIATION_SOLUTION_NAME__。',
          FAIL_STATUS_2:
            '获取问题__ISSUE_KEY__失败 - 执行错误。因此，将无法同步修复状态：__REMEDIATION_SOLUTION_NAME__。',
          FAIL_TICKET_1:
            '无法利用 URL（__URL__）获取票证服务器详细信息：__SERVER_NAME__。无法在资产__USER_REMEDIATION_ASSET_NAMES__上为用户__USER_NAME__创建用于修复__REMEDIATION_UUID__的票证。',
          FAIL_TICKET_2:
            '创建__type__问题失败 - 中断或超时。无法在资产__USER_REMEDIATION_ASSET_NAMES__上为用户__USER_NAME__创建用于修复__REMEDIATION_UUID__的票证。',
          FAIL_TICKET_3:
            '创建__type__问题失败 - 执行错误。无法在资产__USER_REMEDIATION_ASSET_NAMES__上为用户__USER_NAME__创建用于修复__REMEDIATION_UUID__的票证。__type__的错误集合返回：__ERROR_COLLECTION__。',
          FAIL_TICKET_4:
            '利用指定字段映射创建票证时出错。无法在资产__USER_REMEDIATION_ASSET_NAMES__上为用户__USER_NAME__创建用于修复__REMEDIATION_UUID__的票证。',
          MAX_TICKETS:
            '已针对此项目创建 __MAX_TICKET_NUMBER__ 个票证。将无法创建更多票证；如需使用更多票证，请另行创建一个项目。',
          SERVER_DETAILS: '无法检索票证服务器详细信息。',
          STATUS_DETAILS: '无针对此服务器的状态映射。无法更新修复状态。',
          USER_DETAILS: '无针对此项目的分配规则。',
        },
      },
      projects: {
        createProject: '创建项目',
        editProject: '编辑修复项目',
        metrics: {
          numAssignedMeProjects: '分配给我',
          numClosedProjects: '$t(closed)',
          numOpenProjects: '$t(open)',
          numOwnedMeProjects: '由我拥有',
          numProjects: '__numProjects__ 个项目',
        },
        title: '修复项目',
      },
      remediation: {
        entity: {
          assigneeName: '受让人',
          numAssets: '受影响的资产',
          riskReduction: '风险降低',
          status: '状态',
          summary: '解决方案',
          unresolvedVulns: '$t(vulnerabilities)',
        },
        metrics: {
          assigned: '已分配',
          assignedToMe: '分配给我',
          numRemediations: '__numRemediations__ 个解决方案',
          pendingVerification: '待定验证',
          unassigned: '未分配',
          unknownSolutions: '未知解决方案',
        },
        status: {
          AWAITING_VERIFICATION: '等候验证',
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
          OPEN_PENDING: '打开 - 待定',
          REOPEN: '重新打开',
          WILL_NOT_FIX: '将不会修复',
          WILL_NOT_FIX_PENDING: '将不会修复 - 待定',
        },
        tableTitle: '修复解决方案',
        updateError: '更新修复解决方案时出错。',
        updateStatus: '更新状态',
      },
      riskScoreImageTitle: '资产的风险评分增加或降低。',
      solution: {
        entity: {
          additionalInfo: '附加信息',
          fix: '修复',
          solutionId: '解决方案 ID',
          summary: '摘要',
          url: 'URL',
        },
      },
      solutionTitle: '解决方案',
      solutions: '解决方案',
      summaryInformation: '摘要信息',
      ticketing: {
        addConnection: '添加票证连接',
        addRuleInfo: '点击“新建规则”，以添加规则',
        addStatus: '+ 添加状态',
        assignmentRule: '分配规则',
        assignmentRuleDescription:
          '基于源自修复详情中的信息，针对票证的分配对象创建规则。您可创建多条规则并创建规则的应用顺序。',
        assignmentRules: '分配规则',
        assignmentRulesDescription:
          '您可利用分配规则向__type__用户自动分配票证。添加新规则并将下列规则重新排列，以对规则集进行优先排序。按由上至下的优先顺序应用规则。',
        assignmentRulesHeader: '针对__type__项目 __name__创建新的分配规则',
        automatedTicketing: '自动分配票证',
        automatedTickets: '自动化票证',
        automatedTicketsNotConfigured: '未配置自动分配票证',
        changeConnection: '更改连接',
        chooseConnection: '选择项目连接',
        closeWizardWarning:
          '确定要取消？ 将不会保存您的映射和模板。仅会保留票证连接。',
        configurations: '配置',
        configurationsDescription:
          '点击“票证模板名称”，编辑现有配置。点击“新建配置”按钮，添加新配置。',
        configure: '配置',
        configured: '配置__fieldMappingName__',
        configuredWarning:
          '无法更改__type__项目连接。如果您要使用其他票证配置，请创建新的项目。',
        connectionSettings: '连接设置',
        createServerWarning: '您在继续之前必须配置连接',
        defaultAssignee: '默认受让人',
        deleteConnection: '删除连接',
        deleteConnectionDisabled:
          '您有包含活动票证连接的修复项目。为删除票证服务器连接，您必须删除这些项目。',
        deleteServerWarning: '确定要删除此服务器？',
        disabled: '已配置，已禁用',
        enabled: '已配置，已启用',
        error: '已配置，错误',
        errorsDescription: '修复项目的票证出错。请查看下方的错误详细信息。',
        errorsHeader: '修复工作流__projectName__中的票证错误',
        fieldDescription: '字段描述',
        fieldMappingDescription:
          '在创建票证时，指定要设置的值。句法帮助中包含您可利用的变量，以便在票证中包含修复数据。已提供建议的默认值。',
        fieldMappingError: '无法保存字段映射，请稍后重试。',
        fieldMappingHeader: '__type__项目__name__的字段映射',
        fieldMappingNoValuesExist: '此值必填，但无适用于此值的选项。',
        fieldMappingRequired:
          '* 至少须针对每个修复解决方案状态选择一个票证系统状态。',
        fieldMappingSuccess: '字段映射已更新。',
        inactiveWarning: '如要进行编辑，必须激活服务器。',
        integration: '修复票证集成',
        issueKey: '问题密钥',
        issueType: '问题类型',
        manageConnections: '管理票证连接',
        newRule: '新建规则',
        noIssueTypeForProjectKey:
          '请选择其他项目密钥，此项目密钥不包含问题类型',
        notConfigured: '未配置',
        projectAndFieldMapping: '票证项目和字段映射',
        projectError: '在您的__projectName__项目中，共有__count__个票证错误。',
        projectErrorTitle:
          '在修复工作流__projectName__中，共有__count__个票证错误',
        projectKey: '项目密钥',
        projectKeyDescription: '将在选中项目中创建问题',
        projectName: '项目名称',
        remediationStatusButtonWarning:
          '此按钮仅在选中的所有修复均处于相同状态（处于打开/重新打开/等待验证状态）时启用。',
        replacementString: {
          $ASSET_IP_LIST: '逗号分隔的资产 ips. 列表',
          $ASSET_NAME_LIST: '逗号分隔的资产名称列表。',
          $ASSET_OS_LIST: '逗号分隔的资产操作系统列表。',
          $DUE_ON: '修复项目的到期日。',
          $PROJ_NAME: '项目名称。',
          $PROJ_UUID: '项目 uuid。',
          $SOL_ADDL_INFO: '解决方案附加信息。',
          $SOL_FIX: '解决方案修复步骤',
          $SOL_NAME: '解决方案名称。',
          $SOL_URL: '解决方案参考 URL',
          $VULN_ID_LIST: '逗号分隔的漏洞 id 列表。',
        },
        ruleSetName: '规则设置名称',
        schemaSettingsDescription:
          ' 在您的票证服务器中创建连接至特定项目的连接。您稍后可创建连接至其他项目的连接和问题类型。',
        schemaSettingsHeader: '在__name__中连接至票证项目和问题类型',
        selectStatus: '选择状态 *',
        serverConnectionAuthenticationError:
          '无法连接至票证服务器。请验证提供的用户名称和密码是否正确。',
        serverConnectionAuthorizationError:
          '无法连接至票证服务器。请验证提供的账户是否符合下列<a href="https://help.rapid7.com/insightvm/en-us/#Files/Ticketing_integration.html" target="_blank" rel="noopener noreferrer">要求</a>。',
        serverConnectionDeleteError: '无法删除连接，请重试。',
        serverConnectionDeleteSuccess: '已成功删除连接。',
        serverConnectionError: '无法创建服务器连接，请重试。',
        serverConnectionInactiveWarning:
          '已保存服务器连接，但必须激活才能继续。',
        serverConnectionSuccess: '已成功创建服务器连接。',
        serverCreated: '已成功创建票证服务器',
        serverName: '服务器名称',
        serverSettingsDescription: '创建与票证程序（如__type__）实例的连接。',
        serverSettingsDescription2:
          '在这三个步骤中，我们将指导您向__type__项目添加连接和问题类型，以及配置规则。',
        serverSettingsHeader: '连接至__type__票证服务器',
        serverSettingsUserWarning: '此字段需要用户具有下列__type__权限：',
        serverSettingsWarning: '此操作将与__type__服务器建立连接。',
        serverSettingsWarning2:
          '在您将票证连接关联至修复工作流项目之前，将不会生成票证。',
        serviceNowStatusMappingWarning:
          '在执行映射之前，要在 ServiceNow 中创建所需的状态。',
        servicePickerDescription: '点击票证服务，以进行配置',
        servicePickerHeader: '选择票证服务器，以管理连接',
        solutionStatus: '修复解决方案状态',
        solutionStatusMapping: '解决方案状态映射',
        statusMappingDescription:
          '将 InsightVM 中的每个修复状态与票证程序中的项目状态进行匹配。',
        statusMappingError: '无法保存项目修复状态映射，请重试。',
        statusMappingHeader: '设置__name__的解决方案映射',
        statusMappingSuccess: '您的状态映射已更新。',
        syntaxHelp: '句法帮助',
        templateName: '票证模板名称',
        ticketingConnection: '票证连接',
        ticketingSystemStatus: '票证系统项目状态',
        ticketsCreated: '已创建的票证：__count__',
        type: {
          JIRA: 'JIRA',
          SERVICENOW: 'ServiceNow',
        },
        userMappingDescription:
          '创建规则，以基于过滤条件确定票证受让人。从下拉列表中的 Priority 1 开始应用这些规则。如果票证不符合任何规则标准，则不会将其分配给默认受让人。',
        userMappingError: '无法保存用户映射，请稍后重试。',
        userMappingHeader: '__type__ 项目__name__的分配规则集',
        userMappingSuccess: '用户映射已更新。',
        vulnerabilityFilterRequired: '启用票证的项目需使用漏洞过滤器',
        wizardHeader: '票证连接',
      },
      title: '影响您的风险评分的主要修复',
      user: {
        userName: '用户名',
      },
      vulnerabilities: '漏洞',
    },
    range: '__from__-__to__ __unit__',
    reason: '原因',
    references: '参考',
    refresh: '刷新',
    reload: '重新加载',
    remainingInstances: '剩余实例',
    remediated: '已修复',
    remediatedInstances: '已修复的实例',
    remediatedVuln: '已修复的漏洞',
    remediation: '修复',
    remediations: '修复',
    removeWidget: '删除 "__title__" 卡片？',
    removeWidgetTitle: '移除卡片',
    renameDashboard: '重新命名 $t(dashboardLabel)',
    reportedBy: '报告者',
    required: '必填',
    reset: '重置',
    result: '结果',
    reviewStatus: '审查状态',
    risk: '风险',
    riskOverTime: '随着时间推移的风险',
    riskScore: '$t(riskScoreLabel): __riskScore__',
    riskScoreDecrease: '风险评分降低',
    riskScoreIncrease: '风险评分增加',
    riskScoreLabel: '风险评分',
    riskScoreReduction: '风险评分减少',
    riskTrend: '风险趋势',
    ruleCompliance: '规则合规',
    samba: 'Samba CVE-2017-7494',
    sambaWithCve: '包含 $t(samba)',
    save: '保存',
    saveFilter: '保存过滤器',
    scan: '扫描',
    scanDuration: '扫描持续时间',
    scanEngine: '扫描引擎',
    scanHistory: '扫描历史',
    scanStatus: '扫描状态',
    score: '分数',
    search: '搜索',
    seeDetails: '查看详细信息',
    selectAll: '选择全部',
    selectAnOption: '选择一个选项',
    selectNone: '取消选择全部',
    selectedCount: '已选中 __selected__ 个',
    selectedTableText: '(已选中 __total__ 个中的 __selected__ 个)',
    selectionIsEmptyValidation: '请选择一项',
    serviceName: '服务名称',
    services: '服务',
    severe: '中危',
    severity: '严重性：__severity__',
    severityLabel: '严重性',
    shareDashboardWith: '授予访问权给',
    shared: '共享',
    sharedWith: '与 (__count__ $t(user)) 共享',
    sharedWith_plural: '与 (__count__ $t(users)) 共享',
    site: '场所',
    siteName: '场所名称',
    siteTable: {
      inProgress: '扫描进行中',
      notScanned: '未扫描',
      scanFinishedOn: '扫描结束于',
      scanPausedOn: '暂停扫描于',
      scheduledScanFinishedOn: '定期扫描结束于',
      scheduledScanInProgress: '定期扫描进行中',
      scheduledScanPausedOn: '定期扫描暂停于',
    },
    sites: '场所',
    size: '大小',
    software: '软件',
    solution: '解决方案',
    solutions: '解决方案',
    source: '来源',
    sourceLink: '来源链接',
    sourceName: '来源名称',
    sourceType: '来源类型',
    standardPolicies: '标准政策',
    static: '静态',
    status: '状态',
    stockchart: {
      buttons: {
        all: '全部',
        monthText: '__text__月',
        weekText: '__text__周',
        yearText: '__text__年',
        ytd: '年初至今',
      },
    },
    success: '成功',
    successful: '成功',
    summary: '摘要',
    table: {
      errorMessage: '检索失败，请稍后重试。',
      initialError:
        '加载卡片时出错。请稍后尝试<a class="action refresh">重新加载</a>。',
      loading: '正在加载表格数据。',
    },
    tag: '标签',
    taggedAssets: '已标记资产',
    tags: '标签',
    temporalUnit: {
      hours: '小时',
      minutes: '分钟',
      seconds: '秒',
    },
    threatFeed: '威胁来源',
    time: '时间',
    timeSinceLastAssessment: '与上次评估相隔的时间',
    timeUnits: {
      days: '__count__ 天',
      days_plural: '__count__ 天',
      hours: '__count__ 小时',
      hours_plural: '__count__ 小时',
      longerThan: "> $t(timeUnits.__timeUnit__, {'count': __time__})",
      minutes: '__count__ 分钟',
      minutes_plural: '__count__ 分钟',
      months: '__count__ 个月',
      months_plural: '__count__ 个月',
      weeks: '__count__ 周',
      weeks_plural: '__count__ 周',
      years: '__count__ 年',
      years_plural: '__count__ 年',
    },
    title: '标题',
    totalInstances: '全部实例',
    totalRiskScore: '总风险评分',
    totalRiskScoreReduction: '总风险评分减少',
    totalVulns: '漏洞总数',
    trends: '趋势',
    true: '真',
    type: '类型',
    unchanged: '未改变的',
    unknown: '未知',
    unknownOS: '$t(unknown) 操作系统',
    unknownOSVendor: '$t(unknown) 操作系统供应商',
    updateMessage: '您的更改已保存',
    url: 'URL',
    user: '用户',
    username: '用户名',
    users: '用户',
    usersAndGroups: '用户和组',
    vendor: '供应商',
    vendors: '供应商',
    version: '版本',
    vuln: '漏洞',
    vulnTitle: '漏洞标题',
    vulnerabilities: '漏洞',
    vulnerabilitiesOverTime: '随着时间推移的漏洞',
    vulnerability: '漏洞',
    vulnerabilityCount: '$t(vulnerabilities): __vulns__',
    vulnerabilityException: '漏洞例外情况',
    vulnerabilityExceptions: '漏洞例外情况',
    vulnerabilityInstanceStatus: {
      EXCEPTION_VULN_EXPL: '例外情况可入侵的漏洞利用程序',
      EXCEPTION_VULN_POTL: '例外情况可入侵的 POTL',
      EXCEPTION_VULN_VERS: '例外情况可入侵的版本',
      NOT_VULN_DONT_STORE: '不可入侵，勿保存',
      NOT_VULNERABLE: '不可入侵的',
      OVERRIDDEN_VULN_VERS: '覆写漏洞版本',
      SKIPPED_DISABLED: '已跳过，已禁用',
      SKIPPED_DOS: '已跳过的 Dos',
      SKIPPED_VERS: '已跳过的版本',
      SUPERSEDED: '已被取代的',
      UNEXPECTED_ERR: '意外错误',
      UNKNOWN: '未知',
      VULNERABLE_EXPL: '可入侵，已利用',
      VULNERABLE_POTENTIAL: '可入侵，潜在',
      VULNERABLE_VERS: '可入侵的版本',
    },
    vulnerabilityInstances: '漏洞实例',
    vulnerabilityLabel: '漏洞',
    vulnerabilityLabels: {
      criticalVulnerability: '高危 $t(vulnerabilities)',
      moderateVulnerability: '低危 $t(vulnerabilities)',
      severeVulnerability: '中危 $t(vulnerabilities)',
      trendLine: '按随着时间推移的 $t(vulnerability) 严重性划分的 $t(assets)',
      trendLineDescription: '显示了随着时间推移的漏洞趋势的卡片。',
    },
    vulnerabilityTitle: '漏洞名称',
    vulnexception: '$t(vulnerabilityException)',
    vulns: '漏洞',
    vulnsInfo: '漏洞信息',
    wannaCry: 'WannaCry',
    weekOf: '__week__ 周',
    withoutAgents: '无代理',
    yes: '是',
  },
};
